export default __webpack_public_path__ + "static/media/typeform.cc374eb9.svg";